import api from "./API"

export const CartService={
    completedCart:async (data)=>{
        return await api.post(`/save-stone-list`,data)
       
    }
}